var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSiren(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,23.54H6v2.92H0Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,23.54h6v2.92H44Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.43,10.5l4.14-4.14,2.07,2.07L39.5,12.57Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,12.57,6.36,8.43,8.43,6.36l4.14,4.14Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.54,0h2.93V6H23.54Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.82,44.14a2.93,2.93,0,0,0-2.93,2.93V50H41.11V47.07a2.93,2.93,0,0,0-2.93-2.93Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.82,25V41.21H38.18V25a13.18,13.18,0,0,0-26.36,0Zm11.71-4.4h2.93v8.79H23.53Zm0,11.72h2.93v2.93H23.53Z",
    transform: "translate(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSiren);
export default __webpack_public_path__ + "static/media/icon-siren.014b4b3a1503afa0264423d642ed9ff5.svg";
export { ForwardRef as ReactComponent };